module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_partille-bb86f3976d4456e832dcc35ad354a4d1.png";